/**
 * Franchise — the franchise pitch is a single designed poster. We render it
 * exactly as supplied and overlay two transparent hit-areas on top of the
 * printed CTAs so both open the Book-a-Demo lead form (source="franchise").
 * Admin can swap the poster via Site Images → franchise_page_poster.
 */
import React, { useState } from 'react';
import PropitstopNav from '../components/PropitstopNav';
import PropitstopFooter from '../components/PropitstopFooter';
import SEO from '../components/SEO';
import DemoBookingModal from '../components/DemoBookingModal';
import { useSiteImages } from '../hooks/useSiteImages';

const POSTER_DEFAULT =
  'https://customer-assets-eiarnc6j.emergentagent.net/job_fcf8fe40-6235-4ae1-a5a5-ebd4002e0a55/artifacts/scqniydh_ChatGPT%20Image%20Sep%2016%2C%202026%2C%2001_13_37%20PM.png';

// Hit-areas matching the CTAs printed on the poster (percentages of the image).
const CTA_HOTSPOTS = [
  { id: 'franchise-enquiry-cta', label: 'Franchise enquiries now open', left: '3.4%', top: '35.2%', width: '33.5%', height: '3.4%' },
  { id: 'franchise-apply-cta', label: 'Apply for a franchise', left: '69%', top: '93.2%', width: '26.5%', height: '3%' },
];

export default function Franchise() {
  const [demoOpen, setDemoOpen] = useState(false);
  const { imageFor } = useSiteImages();
  const poster = imageFor('franchise_page_poster', POSTER_DEFAULT);

  return (
    <div className="min-h-screen bg-white text-zinc-900 flex flex-col" data-testid="franchise-page">
      <SEO
        title="Car Business Franchise Opportunity in India | Propitstop"
        description="Build an automotive business with multiple revenue streams across used cars, car service, repairs and detailing with Propitstop."
        canonical={typeof window !== 'undefined' ? `${window.location.origin}/franchise` : ''}
      />
      <PropitstopNav />

      <DemoBookingModal
        open={demoOpen}
        onClose={() => setDemoOpen(false)}
        source="franchise"
        accent="bg-red-600 hover:bg-red-700"
        title="Franchise enquiry"
      />

      <main className="flex-1 bg-[#efe8e0] bg-gradient-to-b from-[#f3ede6] via-[#eae2d9] to-[#f5f1ec]">
        <div className="relative w-full max-w-5xl mx-auto shadow-[0_0_80px_rgba(0,0,0,0.08)]">
          <img
            src={poster}
            alt="Own the customer's complete car lifecycle — Propitstop franchise opportunity"
            className="w-full h-auto block"
            data-testid="franchise-poster"
          />
          {CTA_HOTSPOTS.map((h) => (
            <button
              key={h.id}
              type="button"
              onClick={() => setDemoOpen(true)}
              aria-label={h.label}
              data-testid={h.id}
              style={{ left: h.left, top: h.top, width: h.width, height: h.height }}
              className="absolute rounded-full cursor-pointer bg-transparent hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white transition-colors"
            />
          ))}
        </div>
      </main>

      <PropitstopFooter />
    </div>
  );
}
